import React from "react";
import { useUscSelector } from "../../../../redux/store";
import { useUscLabel } from "../../../../utils/labels";
import Text from "../../../../../shared-components/lexus/styles/atoms/Text";
import * as Styles from "./Accessories.styles";
import PackItem from "./PackItem";

const Packs = (): JSX.Element | null => {
    const titleLabel = useUscLabel("uscPdpPacksTitle");

    const packs = useUscSelector((state) => state.accessories.packResults);

    if (!packs.length) return null;

    return (
        <Styles.Wrapper>
            <Text tag="h3" variant="h6">
                {titleLabel}
            </Text>
            {packs.map((pack, index) => (
                <PackItem key={pack.id} pack={pack} index={index} />
            ))}
        </Styles.Wrapper>
    );
};

export default Packs;
